export const DOMAIN_BRANDING = {
  'exodopanel.com': { logo: '/logo1.png', theme: 'exodo', favicon: '/favicon.ico', background: 'exodo' },
  'staging.exodopanel.com': { logo: '/logo1.png', theme: 'exodo', favicon: '/favicon.ico', background: 'exodo' },
  'crm.exodo.id': { logo: '/logo1.png', theme: 'crm', favicon: '/favicon.ico', background: 'exodo' },
  'partner.affland.id': {
    logo: '/logo-affland.png',
    theme: 'affland',
    favicon: '/affland-icons/favicon-affland.ico',
    favicon32: '/affland-icons/favicon-affland-32x32.png',
    favicon16: '/affland-icons/favicon-affland-16x16.png',
    appleTouchIcon: '/affland-icons/apple-touch-icon-affland.png',
    background: 'affland',
  },
  'app.leadscaleglobal.com': {
    logo: '/logo-leadscale.svg',
    theme: 'leadscale',
    favicon: '/leadscale-icons/favicon-leadscale-32x32.png',
    favicon32: '/leadscale-icons/favicon-leadscale-32x32.png',
    favicon16: '/leadscale-icons/favicon-leadscale-16x16.png',
    appleTouchIcon: '/leadscale-icons/apple-touch-icon-leadscale.png',
    background: 'leadscale',
    brandHtml: true,
  },
  'advertiser.exodopanel.com': {
    logo: '/logo-leadscale.svg',
    theme: 'leadscale',
    favicon: '/leadscale-icons/favicon-leadscale-32x32.png',
    favicon32: '/leadscale-icons/favicon-leadscale-32x32.png',
    favicon16: '/leadscale-icons/favicon-leadscale-16x16.png',
    appleTouchIcon: '/leadscale-icons/apple-touch-icon-leadscale.png',
    background: 'leadscale',
    brandHtml: true,
  },
};

/**
 * @param {string} hostname
 * @param {boolean} forceAffland — localhost ?affland=1
 * @param {boolean} forceAdvertiser — legacy localhost ?advertiser=1 (maps to LeadScale)
 * @param {boolean} forceLeadScale — localhost ?leadscale=1
 */
export function getBranding(hostname, forceAffland = false, forceAdvertiser = false, forceLeadScale = false) {
  if (forceLeadScale || forceAdvertiser) return DOMAIN_BRANDING['app.leadscaleglobal.com'];
  if (forceAffland) return DOMAIN_BRANDING['partner.affland.id'];
  return DOMAIN_BRANDING[hostname] ?? DOMAIN_BRANDING['exodopanel.com'];
}

/**
 * Resolve auth UI theme from hostname + query flags (works with server initialHostname).
 */
export function resolveAuthTheme(hostname, searchParams = {}) {
  const get = (key) => {
    if (!searchParams) return null;
    if (typeof searchParams.get === 'function') return searchParams.get(key);
    return searchParams[key] ?? null;
  };
  const host = String(hostname || '').split(':')[0].toLowerCase();
  const isLocal = host === 'localhost' || host === '127.0.0.1' || host === '';
  const forceAffland = get('affland') === '1';
  const forceLeadScale =
    get('leadscale') === '1' || get('advertiser') === '1';
  const branding = getBranding(host, forceAffland, false, forceLeadScale);
  const isAfflandTheme = host === 'partner.affland.id' || (isLocal && forceAffland);
  const isLeadScaleTheme =
    branding.theme === 'leadscale' ||
    host === 'app.leadscaleglobal.com' ||
    host === 'advertiser.exodopanel.com' ||
    (isLocal && forceLeadScale);
  return {
    branding,
    isAfflandTheme,
    isLeadScaleTheme,
    /** @deprecated use isLeadScaleTheme — advertiser host now shares LeadScale UI */
    isAdvertiserTheme: isLeadScaleTheme,
    forceAffland,
    forceLeadScale,
  };
}
